import { render } from "./inject-tag.vue?vue&type=template&id=8577a1f6"
import script from "./inject-tag.vue?vue&type=script&lang=js"
export * from "./inject-tag.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__